import { useEffect, useState } from "react";
import {
  getNewsletters,
  sendNewsletter,
} from "../services/admin.newsletters.service";
import { useToast } from "../context/ToastContext";

import NewsletterHeader from "../components/newsletter/NewsletterHeader";
import NewsletterTable from "../components/newsletter/NewsletterTable";
import NewsletterCreateModal from "../components/newsletter/NewsletterCreateModal";
import NewsletterDetailsModal from "../components/newsletter/NewsletterDetailsModal";

export default function NewsLetter() {
  const { showToast } = useToast();
  const [data, setData] = useState({ data: [], last_page: 1, total: 0 });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState("all");
  const [openCreate, setOpenCreate] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    loadNewsletters();
  }, [page, search, roleFilter]);

  async function loadNewsletters() {
    setLoading(true);
    try {
      const params = {
        page,
        search,
        role: roleFilter,
      };
      const response = await getNewsletters(params);
      setData(response);
    } catch (err) {
      showToast("Erreur de chargement", "error");
    } finally {
      setLoading(false);
    }
  }

  async function handleCreate(payload) {
    try {
      await sendNewsletter(payload);
      showToast("Message diffusé avec succès", "success");
      setOpenCreate(false);
      setPage(1);
      loadNewsletters();
    } catch (err) {
      showToast(
        err.response?.data?.message || "Erreur lors de l'envoi",
        "error",
      );
    }
  }

  if (loading && data.data.length === 0) {
    return <div className="loaderContainer">Chargement des newsletters...</div>;
  }

  return (
    <div className="page">
      <NewsletterHeader
        total={data.total}
        search={search}
        onSearch={(v) => {
          setSearch(v);
          setPage(1);
        }}
        onAdd={() => setOpenCreate(true)}
        roleFilter={roleFilter}
        onRoleChange={(v) => {
          setRoleFilter(v);
          setPage(1);
        }}
      />

      <div className={loading ? "tableContainer loading" : "tableContainer"}>
        <NewsletterTable newsletters={data.data} onView={setSelected} />
      </div>

      <div className="paginationContainer">
        <div className="pagiInfo">
          Page <strong>{page}</strong> sur {data.last_page}
        </div>
        <div className="pagiControls">
          <button
            className="pagiBtn"
            disabled={page === 1 || loading}
            onClick={() => setPage((p) => p - 1)}
          >
            Précédent
          </button>
          <button
            className="pagiBtn"
            disabled={page === data.last_page || loading}
            onClick={() => setPage((p) => p + 1)}
          >
            Suivant
          </button>
        </div>
      </div>

      <NewsletterCreateModal
        open={openCreate}
        onClose={() => setOpenCreate(false)}
        onSubmit={handleCreate}
      />
      <NewsletterDetailsModal tr={selected} onClose={() => setSelected(null)} />
    </div>
  );
}
